import type { IMoveSectionProp, IMoveSectionResponse } from './types';
import { fetch } from '../fetchWrapper/fetch';
import { API_URL, Status } from '../constants';

export const moveSection = async ({
  menuId,
  sectionId,
  newDisplayOrder,
}: IMoveSectionProp): Promise<IMoveSectionResponse> => {
  const uri = `${API_URL}/menus/${menuId}/sections/${sectionId}/reorder`;
  try {
    const res = await fetch(uri, {
      method: 'PATCH',
      body: JSON.stringify({ display_order: newDisplayOrder }),
      cache: 'reload',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });

    if (res.status === Status.NO_CONTENT) {
      return;
    }

    throw new Error('Unexpected response code', { cause: `Response code of ${res.status} returned` });
  } catch (e) {
    throw new Error('Could not move section', { cause: e });
  }
};
